<script>
	const _ = require('underscore');

	module.exports = {
		props: {
			'highlight-click': {
				type: Function,
				default: _.noop
			},
			'note-click': {
				type: Function,
				default: _.noop
			},
			minimal: {
				default: false
			},
			'force-mobile': {
				default: false
			}
		},
		data: function () {
			return {
				showingPrompt: false,
				highlight: null
			};
		},
		mounted() {
			var haveTouchEvents = false;

			// mobile devices have touchend AND click. In that case we want to
			// accept the touchend (which comes first) and then reject clicks
			// which are duplicate events.
			//
			// On desktop we need the click events for testing, so we can't just
			// only handle touch events
			this.throttledHighlightClick = function (style, ev) {
				if (ev.type.substring(0, 5) === 'touch') {
					haveTouchEvents = true;
				} else if (ev.type === 'click' && haveTouchEvents) {
					return;
				}

				this.highlightClick(style);
			}.bind(this);

			this.throttledNoteClick = function (ev) {
				if (ev.type.substring(0, 5) === 'touch') {
					haveTouchEvents = true;
				} else if (ev.type === 'click' && haveTouchEvents) {
					return;
				}

				this.noteClick();
			}.bind(this);
		},
		methods: {
			show: function (positions, highlight) {
				this.highlight = highlight;
				var $prompts = $(this.$refs.promptMobile).add(this.$refs.promptDesktop);
				var $offsetParent = $(positions.offsetParent);

				$prompts.css({
					top: -9000,
					left: -9000
				});

				var clipTo = function (v, min, max) {
					if (v < min) {
						return min;
					} else if (v > max) {
						return max;
					} else {
						return v;
					}
				};

				var minLeft = 0;
				var maxLeft = $offsetParent.width() - $(this.$refs.promptDesktop).outerWidth();

				var desktopLeft;

				// if whole selection on 1 line, then center the prompt over it
				if (Math.abs(positions.start.top - positions.end.top) < 15) {
					desktopLeft = (positions.start.left + positions.end.left) / 2;
				} else {
					// if selection spans multiple lines, then put the prompt mid-way between
					// the start and the end of the first line (another way to center)
					desktopLeft = (positions.start.left + $(positions.contentElement).width()) / 2;
				}
				desktopLeft -= $(this.$refs.promptDesktop).outerWidth() / 2;

				$(this.$refs.promptDesktop).css({
					top: positions.start.top - $(this.$refs.promptDesktop).outerHeight() - 12,
					left: desktopLeft
				});

				var mobileLeft;

				// if whole selection on 1 line, then center the prompt under it
				if (Math.abs(positions.start.top - positions.end.top) < 15) {
					mobileLeft = (positions.start.left + positions.end.left) / 2;
				} else {
					// if selection spans multiple lines, then put the prompt mid-way between
					// the end and the beginning of the last line (another way to center)
					mobileLeft = positions.end.left / 2;
				}

				mobileLeft -= $(this.$refs.promptMobile).outerWidth() / 2;

				$(this.$refs.promptMobile).css({
					top: positions.end.bottom + 12,
					left: clipTo(mobileLeft, minLeft, maxLeft)
				});

				this.showingPrompt = true;
			},
			hide: function () {
				this.showingPrompt = false;
			}
		}
	};
</script>
<template>
	<div>
		<div
			ref="promptDesktop"
			v-bind:class="{ 'annotation-prompt': true, 'force-mobile': forceMobile, 'arrow-down': true, 'in-use': showingPrompt }"
			v-on:click.prevent.stop>
			<a
				v-if="!minimal"
				v-bind:class="{ highlight: true, orange: true, selected: highlight && highlight.style === 'o' && !highlight.textNote }"
				v-on:mousedown.prevent
				v-on:click="highlightClick('o')">
			</a>
			<a
				v-if="!minimal"
				v-bind:class="{ highlight: true, green: true, selected: highlight && highlight.style === 'g' && !highlight.textNote }"
				v-on:mousedown.prevent
				v-on:click="highlightClick('g')">
			</a>
			<a
				v-if="!minimal"
				v-bind:class="{ highlight: true, purple: true, selected: highlight && highlight.style === 'p' && !highlight.textNote }"
				v-on:mousedown.prevent
				v-on:click="highlightClick('p')">
			</a>
			<a
				v-bind:class="{ highlight: true, blue: true, selected: highlight && highlight.style === 'b' && !highlight.textNote }"
				v-on:mousedown.prevent
				v-on:click="highlightClick('b')">
			</a>
			<a
				v-if="!minimal"
				v-on:click="noteClick()"
				v-on:mousedown.prevent>
				<note-icon classes="icon"></note-icon>
			</a>
		</div>
		<div
			ref="promptMobile"
			v-bind:class="{ 'annotation-prompt': true, 'force-mobile': forceMobile, 'arrow-up': true, 'in-use': showingPrompt }"
			v-on:click.prevent.stop
			v-on:touchstart.prevent.stop
			v-on:touchend.prevent.stop>
			<a
				v-if="!minimal"
				v-bind:class="{ highlight: true, orange: true, selected: highlight && highlight.style === 'o' && !highlight.textNote }"
				v-on:mousedown.prevent
				v-on:touchend="throttledHighlightClick('o', $event)"
				v-on:click="throttledHighlightClick('o', $event)">
			</a>
			<a
				v-if="!minimal"
				v-bind:class="{ highlight: true, green: true, selected: highlight && highlight.style === 'g' && !highlight.textNote }"
				v-on:mousedown.prevent
				v-on:touchend="throttledHighlightClick('g', $event)"
				v-on:click="throttledHighlightClick('g', $event)">
			</a>
			<a
				v-if="!minimal"
				v-bind:class="{ highlight: true, purple: true, selected: highlight && highlight.style === 'p' && !highlight.textNote }"
				v-on:mousedown.prevent
				v-on:touchend="throttledHighlightClick('p', $event)"
				v-on:click="throttledHighlightClick('p', $event)">
			</a>
			<a
				v-bind:class="{ highlight: true, blue: true, selected: highlight && highlight.style === 'b' && !highlight.textNote }"
				v-on:mousedown.prevent
				v-on:touchend="throttledHighlightClick('b', $event)"
				v-on:click="throttledHighlightClick('b', $event)">
			</a>
			<a
				v-if="!minimal"
				v-on:click.prevent="throttledNoteClick($event)"
				v-on:touchend="throttledNoteClick($event)"
				v-on:mousedown.prevent>
				<note-icon classes="icon"></note-icon>
			</a>
		</div>
	</div>
</template>
